import { useRef, useState } from 'react';
import { DoubleLeftOutlined, DoubleRightOutlined } from '@ant-design/icons';
import { Trans, useTranslation } from 'react-i18next';
import { useWebchatStore } from '@/store/webchat.store';
import { TranslationLogPanel } from '../translation-log-panel/translation-log-panel';
import styles from './logs-sidebar.module.scss';
import clsx from 'clsx';

export const LogsSidebar = () => {
  const { t } = useTranslation('webchat');
  const [collapsed, setCollapsed] = useState(false);
  const selectedConversationId = useWebchatStore((s) => s.selectedConversationId);

  // Keep showing the last conversation's logs after session_closed
  // (session is removed from the list but bridgeLogs are retained in the store).
  const lastConvIdRef = useRef<number | null>(null);
  if (selectedConversationId != null) {
    lastConvIdRef.current = selectedConversationId;
  }
  const displayConversationId = selectedConversationId ?? lastConvIdRef.current;

  return (
    <div className={clsx(styles.sidebar, collapsed && styles.collapsed)}>
      <button
        className={styles.toggleBtn}
        onClick={() => setCollapsed((c) => !c)}
        title={collapsed ? t('logsSidebar.show') : t('logsSidebar.hide')}
      >
        {collapsed ? <DoubleLeftOutlined /> : <DoubleRightOutlined />}
        <span className={styles.toggleLabel}>{t('logsSidebar.toggleLabel')}</span>
      </button>
      <div className={styles.content}>
        <div className={styles.header}>
          {t('logsSidebar.header')}
          {selectedConversationId == null && displayConversationId != null && (
            <span className={styles.endedBadge}>{t('logsSidebar.ended')}</span>
          )}
        </div>
        <div className={styles.logWrapper}>
          {displayConversationId != null ? (
            <TranslationLogPanel conversationId={displayConversationId} />
          ) : (
            <div className={styles.empty}>
              <Trans ns="webchat" i18nKey="logsSidebar.empty" components={{ br: <br /> }} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
